import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { InventarioService } from "src/app/views/materials/inventario/inventario.service";
import { MaterialsService } from "src/app/views/materials/materials/materials.service";
import { MovimientosModal } from "src/app/views/materials/modal/modal.component";
import { LayoutsService } from "../../services/layouts.service";
import { FabButtonService } from "src/app/services/fab-button.service";

@Component({
  selector: "app-inventari",
  templateUrl: "./inventario.component.html",
})
export class InventarioLayout implements OnInit, OnDestroy {
  list: any[] = [];
  constructor(
    public service: MaterialsService,
    public invServ: InventarioService,
    public dialog: MatDialog,
    public layout: LayoutsService,
    private alerts: AlertasSwalService,
    private fab: FabButtonService
  ) {}

  btnEntradas = {
    backgroundClass: "bg-blue-500 hover:w-52",
    iconClass: "fas fa-plus",
    title: "Entrada de material",
    action: () => {
      this.openEntry();
    },
  };


  btnSalidas = {
    backgroundClass: "bg-red-500 hover:w-52",
    iconClass: "fas fa-minus",
    title: "Salida de material",
    action: () => {
      this.openExit();
    },
  };
  ngOnInit(): void {
    this.loadRecords();
    this.layout.changeHeader("Materiales");
    this.fab.setButtons([this.btnSalidas, this.btnEntradas]);
  }
  ngOnDestroy(): void {
    this.fab.removeButton(this.btnEntradas);
    this.fab.removeButton(this.btnSalidas);
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.list = resultData;
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  async openEntry() {
    const result = await this.dialog
      .open(MovimientosModal, {
        panelClass: ["w-full", "lg:w-1/2"],
        data: {
          list: this.list,
          title: "Entrada de material",
          label: "Material",
          isEntry: true,
        },
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.invServ.entry(result).subscribe(
        (event) => {
          this.alerts.correcta("Correcto", "Entradas registrada");
          this.loadRecords();
        },
        (err) => {
          this.alerts.error("Error", "Ocurrio un error");
        }
      );
    }
  }

  async openExit() {
    const result = await this.dialog
      .open(MovimientosModal, {
        panelClass: ["w-full", "lg:w-1/2"],
        data: {
          list: this.list,
          title: "Salida de material",
          label: "Material",
          isEntry: false,
        },
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.invServ.exit(result).subscribe(
        (event) => {
          this.alerts.correcta("Correcto", "Salida registrada");
          this.loadRecords();
        },
        (err) => {
          this.alerts.error("Error", "Ocurrio un error");
        }
      );
    }
  }
}
